/* eslint-disable @typescript-eslint/naming-convention */
export enum BtnClasses {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  DANGER = 'warning',
  DEFAULT = 'default',
  TERTIARY = 'tertiary',
  INVERSE = 'inverse',
  LINK_PRIMARY = 'link-primary',
  LINK_SECONDARY = 'link-secondary',
  LINK_DANGER = 'link-warning',
}

export type AlertRole = 'alert' | 'alertdialog' | 'status';
